"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

// Components
import GameCard from "@/components/GameCard/GameCard";
import FilterStatic from "@/components/filter-static";
import Pagination from "@/components/pagination";
import IconSprite from "@/components/UI/IconSprite";
import PageHeader from "src/components/layouts/page-header";

// Hooks
import { useGamesFetch } from "@/domains/games/hooks/use-games-fetch";

// Definitions
import type { SelectItemType } from "@/components/select-sorter";
import { SORT_BASE_KEYS, SORT_ORDER_KEYS, SORT_PARAM_KEYS } from "@/types/filter";
import type { GameType, GamesFilterParamsType } from "@/domains/games/types";

// Utils
import st from "./index.module.scss";
// import { useOneProviderFetch } from "@/domains/providers/hooks/use-providers-fetch";

type ProvidersViewType = {
  searchParams: GamesFilterParamsType;
  slug: string;
};

export default function ProviderGames(props: ProvidersViewType) {
  const { searchParams, slug } = props;

  const t = useTranslations("ProviderPage");

  const searchParamsEntries = Object.entries(searchParams);
  const defaultSort = { [SORT_PARAM_KEYS.sortBy]: SORT_BASE_KEYS.popularity };
  const sortParams = !searchParamsEntries.length ? defaultSort : searchParams;
  const gamesFetchParams = { provider: slug, ...sortParams };
  const { games, pagination } = useGamesFetch(gamesFetchParams);
  // const { provider } = useOneProviderFetch(slug);
  const [localData, setLocalData] = useState<GameType[]>([]);

  useEffect(() => {
    games.length && setLocalData(games);
  }, [games]);

  useEffect(() => {
    searchParams.page && setLocalData([...localData, ...games]);
  }, [games, searchParams]);

  const optionsSort: SelectItemType[] = [
    {
      id: 1,
      value: SORT_BASE_KEYS.popularity,
      label: t("sort.popularity"),
      field: SORT_PARAM_KEYS.sortBy,
      icon: IconSprite({ name: "fire-stroke" }),
    },
    {
      id: 3,
      value: SORT_ORDER_KEYS.desc,
      label: t("sort.a_z"),
      field: SORT_PARAM_KEYS.order,
      icon: IconSprite({ name: "a-z" }),
    },
    {
      id: 2,
      value: SORT_ORDER_KEYS.asc,
      label: t("sort.z_a"),
      field: SORT_PARAM_KEYS.order,
      icon: IconSprite({ name: "z-a" }),
    },
  ];

  return (
    <div className="section">
      <PageHeader title={`${slug.toUpperCase()} - ${t("title")}`} isBackButton />
      <FilterStatic searchParams={searchParams} optionsSort={optionsSort} />
      {localData.length > 0 && (
        <ul className={st.list}>
          {localData.map((item) => {
            return (
              <li className={st.list__item} key={item.slug}>
                <GameCard item={item} />
              </li>
            );
          })}
        </ul>
      )}
      <Pagination pagination={pagination} searchParams={searchParams} />
    </div>
  );
}
